<div class="modal-header hiw-modal-header">
  <div class="hiw-title text-center mb-2 uppercase">
    <div [translate]="'modal.howItWorks.orderingProcessHeader'"></div>
    <div class="hiw-sub-title" [translate]="'modal.howItWorks.orderingProcessSubHeader'"></div>
  </div>
  <i class="icon-close" (click)="modal.dismiss()"></i>
</div>
<div class="modal-body hiw-modal-body">
  <div class="hiw-container hiw-component-wrap">
    <how-it-works [isCursorPointer]="false" [modalMode]="true"></how-it-works>
  </div>

  <div class="hiw-question">
    <div class="hiw-container">
      <span class="hiw-any-question"
            [translate]="'modal.howItWorks.doYouHaveAnyQuestions'">Do you have any questions?</span>&nbsp;
      <a href="#" (click)="$event.preventDefault(); contactUs()" class="text-pink"
         [translate]="'common.clickHere'">Click here</a>
    </div>
  </div>

<!--  <div class="hiw-container">-->
<!--    <div class="hiw-title hiw-title-check-order text-center fw-bold"-->
<!--         [translate]="'modal.howItWorks.checkOrderDeadline'">-->
<!--      Check order deadline. Search for city or bakery-->
<!--    </div>-->

<!--    <div class="hiw-bakery-search-col" #scrollContainer>-->
<!--      <div class="hiw-bakery-search-input">-->
<!--        <ui-input-loader-wrap [loading]="busy">-->
<!--          <input type="text" class="form-control"-->
<!--                 placeholder="{{'modal.howItWorks.searchForPlacePlaceholder' | translate}}"-->
<!--                 [(ngModel)]="placeName"-->
<!--                 (ngModelChange)="fieldChange$.next($event)">-->
<!--        </ui-input-loader-wrap>-->
<!--        <i class="icon-search"></i>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div *ngIf="bakeries && bakeries.length">-->
<!--      <div class="hiw-row-border" *ngFor="let bakery of bakeries">-->
<!--        <hiw-bakery-row [bakery]="bakery"></hiw-bakery-row>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="hiw-bakery-search-col" *ngIf="nothingFound && placeName">-->
<!--      <ui-message [type]="'info'">-->
<!--        <span [translate]="'modal.howItWorks.nothingFound'"></span>-->
<!--      </ui-message>-->
<!--    </div>-->
<!--  </div>-->
</div>
